import React from 'react';
import { Grid } from 'semantic-ui-react';
import ColumnValidationError from '@/components/errors/ColumnValidationError';
import { states } from '@/constants/lifecycle';
import { findMatch } from '@/utils/resultsHelper';
import DatasourceTypeDropdown from './DatasourceTypeDropdown';
import DatasourceDatabaseFields, { validateDatasourceDatabaseFields } from './DatasourceDatabaseFields';
import DatasourceTokenFields, { validateDatasourceTokenFields } from './DatasourceTokenFields';
import DatasourceCompactDatabaseFields from './DatasourceCompactDatabaseFields';
import DatasourceCompactTokenFields from './DatasourceCompactTokenFields';
import { datasourceTypePorts, externalDatasourceTypes, tokenDatasources } from '../constants';

const databaseFields = {
  compact: DatasourceCompactDatabaseFields,
  editor: DatasourceDatabaseFields,
  validator: validateDatasourceDatabaseFields,
};

export const datasetDatasourceSettingsComponents = {
  [externalDatasourceTypes.POSTGRES]: { ...databaseFields },
  [externalDatasourceTypes.SQL_SERVER]: { ...databaseFields },
  [externalDatasourceTypes.SYNAPSE]: { ...databaseFields },
  [externalDatasourceTypes.FEDERATED_NODE]: {
    compact: DatasourceCompactTokenFields,
    editor: DatasourceTokenFields,
    validator: validateDatasourceTokenFields,
  },
};

const DatasourceForm = ({
  autoFocus,
  compact,
  readStatus,
  settings,
  supportedTypes,
  updateSettings,
}) => {
  const FieldComponent = compact ? datasetDatasourceSettingsComponents[settings.type]?.compact
    : datasetDatasourceSettingsComponents[settings.type]?.editor;

  const datasourceTypeChange = (e, { value }) => {
    const portValue = datasourceTypePorts[value];
    const usernameValue = tokenDatasources.includes(value) ? null : settings.username;
    updateSettings({ type: value, port: portValue, username: usernameValue });
  };

  return (
    <Grid columns="equal" className="aridhia-datasource-form-content aridhia-modal-grid">
      <Grid.Row>
        <ColumnValidationError
          htmlFor="datasource_type_dropdown"
          labelId="save.dataset.datasource.type"
          position="right"
        >
          <DatasourceTypeDropdown
            autoFocus={autoFocus}
            disabled={readStatus !== states.SUCCESS || settings.saveStatus === states.PENDING}
            locked={settings.source_exists}
            onChange={datasourceTypeChange}
            supportedTypes={supportedTypes}
            value={settings.type}
            withDescription
          />
        </ColumnValidationError>
      </Grid.Row>
      {FieldComponent && (
        <FieldComponent
          compact={compact}
          disabled={settings.saveStatus === states.PENDING || !findMatch(supportedTypes, settings.type)?.enabled}
          settings={settings}
          updateSettings={updateSettings}
        />
      )}
    </Grid>
  );
};

export default DatasourceForm;
